import { z } from "zod";

/** Helper function to validate a form field. */
export const validateField = (
  ctx: z.RefinementCtx,
  path: string,
  schema: z.ZodSchema,
  value: unknown
) => {
  const result = schema.safeParse(value);
  if (result.success) return;

  ctx.addIssue({
    code: "custom",
    path: [path],
    message: result.error.issues[0]?.message ?? "Invalid value",
  });
};
